var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", color: "primary", dark: "" },
                      nativeOn: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.asignarHorario()
                        }
                      },
                      slot: "activator"
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                      _vm._v(" Asignar Horarios")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nueva Asignación")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-refresh",
                      attrs: { slot: "activator" },
                      nativeOn: {
                        click: function($event) {
                          return function() {
                            _vm.filterShow = _vm.filterShow ? false : true
                          }.apply(null, arguments)
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("filter_list")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Búsqueda/filtros")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                { attrs: { bottom: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-refresh",
                      attrs: { slot: "activator" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cargarPersonasHorarios()
                        }
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("refresh")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filterShow,
                            expression: "filterShow"
                          }
                        ],
                        staticClass: "filter-container-rrhh"
                      },
                      [
                        _c(
                          "v-icon",
                          { attrs: { small: "", color: "primary" } },
                          [_vm._v("search")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Nombres", type: "text" },
                              on: {
                                input: function($event) {
                                  return _vm.filterNombres(_vm.form.nombres)
                                }
                              },
                              model: {
                                value: _vm.form.nombres,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "nombres", $$v)
                                },
                                expression: "form.nombres"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Ap paterno", type: "text" },
                              on: {
                                input: function($event) {
                                  return _vm.filterPaterno(_vm.form.ap_paterno)
                                }
                              },
                              model: {
                                value: _vm.form.ap_paterno,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ap_paterno", $$v)
                                },
                                expression: "form.ap_paterno"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "filter-item" },
                          [
                            _c("v-text-field", {
                              attrs: { label: "Ap materno", type: "text" },
                              on: {
                                input: function($event) {
                                  return _vm.filterMaterno(_vm.form.ap_materno)
                                }
                              },
                              model: {
                                value: _vm.form.ap_materno,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ap_materno", $$v)
                                },
                                expression: "form.ap_materno"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-filter" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      small: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.recargar()
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("refresh")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Recargar filtros")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    nativeOn: {
                                      click: function($event) {
                                        return function() {
                                          _vm.filterShow = false
                                          _vm.recargar()
                                        }.apply(null, arguments)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("close")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Cerrar filtros")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.l_horarios_personas,
                  pagination: _vm.pagination,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros",
                  "disable-initial-sort": true,
                  "no-results-text": "No se encontraron coincidencias",
                  loading: _vm.loading,
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  "rows-per-page-items": [10, 25, { text: "Todos", value: -1 }]
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                attrs: { id: "cabecera_tabla" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "white" } },
                                  [_vm._v("arrow_upward")]
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c(
                          "td",
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(items.item.ap_paterno) +
                                "\n            " +
                                _vm._s(items.item.ap_materno) +
                                " " +
                                _vm._s(items.item.nombres) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "v-chip",
                              {
                                staticStyle: { "font-size": "0.8em" },
                                attrs: {
                                  small: "",
                                  color: "rgb(0, 134, 191)",
                                  dark: ""
                                }
                              },
                              [_vm._v("CI: " + _vm._s(items.item.nro_doc))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            items.item.horarios.length === 0
                              ? _c("span", [
                                  _vm._v("NO TIENE HORARIOS ASIGNADOS")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-expansion-panel",
                              _vm._l(items.item.horarios, function(horario) {
                                return _c(
                                  "v-expansion-panel-content",
                                  {
                                    key: horario.id,
                                    staticClass: "panel-reducido",
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function() {
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      horario.descripcion
                                                    ) +
                                                    ":\n                    " +
                                                    _vm._s(
                                                      _vm
                                                        .$moment(
                                                          horario.hora_inicio,
                                                          "HH:mm:ss"
                                                        )
                                                        .format("HH:mm")
                                                    ) +
                                                    "\n                    -\n                    " +
                                                    _vm._s(
                                                      _vm
                                                        .$moment(
                                                          horario.hora_fin,
                                                          "HH:mm:ss"
                                                        )
                                                        .format("HH:mm")
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "v-card",
                                      [
                                        _c(
                                          "v-card-text",
                                          { staticClass: "p-1" },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                staticClass: "text-xs-center",
                                                attrs: { wrap: "", row: "" }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", md6: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "blue--text"
                                                      },
                                                      [_vm._v("Hora inicio: ")]
                                                    ),
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          horario.hora_inicio
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", md6: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "blue--text"
                                                      },
                                                      [_vm._v("Hora fin: ")]
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          horario.hora_fin
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.horario_personas.length > 0
                                  ? _vm
                                      .$moment(
                                        items.item.horario_personas[0]
                                          .fecha_desde
                                      )
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      color: "primary",
                                      icon: "",
                                      dark: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.personaHorario(items.item)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [
                                    _c("v-icon", [_vm._v("add_circle_outline")])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Asignar Horario")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      color: "primary",
                                      icon: "",
                                      dark: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.verHorarioContinuoDiscontinuo(
                                          items.item
                                        )
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("visibility")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("Ver historico de horarios")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      color: "orange",
                                      icon: "",
                                      dark: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.personaHorarioEspecial(
                                          items.item
                                        )
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("event_note")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Asignar Horario Especial")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      color: "orange",
                                      icon: "",
                                      dark: ""
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.verHorariosEspeciales(
                                          items.item
                                        )
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("visibility")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Ver horarios especiales")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "expand",
                    fn: function(props) {
                      return [
                        _c(
                          "v-card",
                          { attrs: { flat: "" } },
                          [
                            _c("v-card-text", [
                              _vm._v(_vm._s(props.item.nombres))
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff33b13a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff33b13a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asignacion_horario/components/ListadoPersona.vue
// module id = null
// module chunks = 